import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  Avatar,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  KeyboardArrowDown,
  // Person,
  Logout,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import LogoutModal from "../common/LogoutModal";
import logo from "../../assets/logo.png";
import dashboard from "../../assets/dashboard.png";
import dashboardActive from "../../assets/dashboardActive.png";
import user from "../../assets/user.png";
import userActive from "../../assets/userActive.png";
import report from "../../assets/report.png";
import reportActive from "../../assets/reportActive.png";
import chatAi from "../../assets/chatAi.png";
import chatAiActive from "../../assets/chatAiActive.png";
import subscriptions from "../../assets/subscriptions.png";
import subscriptionsActive from "../../assets/subscriptionsActive.png";
import compatibilityAi from "../../assets/compatibilityAi.png";
import compatibilityAiActive from "../../assets/compatibilityAiActive.png";
import prediction from "../../assets/prediction.png";
import predictionActive from "../../assets/predictionActive.png";
import transactions from "../../assets/transactions.png";
import transactionsActive from "../../assets/transactionsActive.png";

const drawerWidth = 280;

const menuSections = [
  {
    title: "",
    items: [
      { text: "Dashboard", icon: { inactive: dashboard, active: dashboardActive }, path: "/dashboard" },
    ]
  },
  {
    title: "Management",
    items: [
      { text: "User", icon: { inactive: user, active: userActive }, path: "/users" },
      { text: "Report", icon: { inactive: report, active: reportActive }, path: "/report" },
      { text: "Chat AI", icon: { inactive: chatAi, active: chatAiActive }, path: "/chat-ai" },
      { text: "Subscriptions", icon: { inactive: subscriptions, active: subscriptionsActive }, path: "/subscriptions" },
      { text: "Compatibility AI", icon: { inactive: compatibilityAi, active: compatibilityAiActive }, path: "/compatibility-ai" },
      { text: "Prediction", icon: { inactive: prediction, active: predictionActive }, path: "/prediction" },
    ]
  },
  {
    title: "Finance",
    items: [
      { text: "Transactions", icon: { inactive: transactions, active: transactionsActive }, path: "/transactions" },
    ]
  }
];

const Sidebar = ({ mobileOpen, onMobileClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getUserName, getUserInitials } = useAuth();
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleNavigation = (path) => {
    navigate(path);
    if (onMobileClose) {
      onMobileClose();
    }
  };

  const handleUserClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // const handleProfileClick = () => {
  //   handleMenuClose();
  //   navigate("/settings");
  //   if (onMobileClose) {
  //     onMobileClose();
  //   }
  // };

  const handleLogoutClick = () => {
    handleMenuClose();
    setLogoutModalOpen(true);
  };

  const handleCloseLogoutModal = () => {
    setLogoutModalOpen(false);
  };

  const drawerContent = (
    <Box>
      {/* Logo Section */}
      <Box sx={{
        height: "130px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderBottom: "1px solid #404040",
        padding: "0 20px"
      }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
            src={logo}
            alt="AstroGuru"
            style={{ width: "30px", height: "30px" }}
          />
          <Typography sx={{ color: "#FFFFFF", fontSize: "16px", fontWeight: 600 }}>
            ASTROGURU
          </Typography>
        </Box>
      </Box>

      {/* Content Container */}
      <Box sx={{
        height: "calc(100vh - 130px)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}>
        {/* Menu Section - Scrollable */}
        <Box sx={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          padding: "20px 0",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "rgba(255, 255, 255, 0.05)",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "rgba(204, 158, 73, 0.3)",
            borderRadius: "3px",
            "&:hover": {
              background: "rgba(204, 158, 73, 0.5)",
            }
          }
        }}>
          {menuSections.map((section, sectionIndex) => (
            <Box key={sectionIndex} sx={{ marginBottom: 3 }}>
              {section.title && (
                <Typography
                  sx={{
                    color: "#888888",
                    fontSize: "12px",
                    fontWeight: 500,
                    textTransform: "uppercase",
                    padding: "0 20px",
                    marginBottom: "10px",
                    letterSpacing: "0.5px"
                  }}
                >
                  {section.title}
                </Typography>
              )}
              <List sx={{ padding: 0 }}>
                {section.items.map((item) => (
                  <ListItem key={item.text} disablePadding>
                    <ListItemButton
                      onClick={() => handleNavigation(item.path)}
                      sx={{
                        backgroundColor: "transparent",
                        color: location.pathname === item.path ? "#E1AD01" : "#CCCCCC",
                        "&:hover": {
                          backgroundColor: "#333333",
                        },
                        padding: "8px 20px",
                        borderRadius: 0,
                        borderLeft: location.pathname === item.path ? "3px solid #E1AD01" : "3px solid transparent",
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: "30px", display: 'flex', alignItems: 'center' }}>
                        <img
                          src={location.pathname === item.path ? item.icon.active : item.icon.inactive}
                          alt={`${item.text} icon`}
                          style={{ width: 20, height: 20, objectFit: 'contain' }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={item.text}
                        sx={{
                          "& .MuiListItemText-primary": {
                            fontWeight: location.pathname === item.path ? 600 : 400,
                            fontSize: "14px",
                            color: location.pathname === item.path ? "#E1AD01" : "#CCCCCC",
                          },
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Box>
          ))}
        </Box>

        {/* User Profile Section - Fixed */}
        <Box sx={{
          flexShrink: 0,
          padding: "16px",
          paddingBottom: "20px",
          backgroundColor: "rgba(26, 26, 26, 1)",
          borderTop: "1px solid rgba(64, 64, 64, 0.3)",
        }}>
          <Box
            onClick={handleUserClick}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 3,
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "rgba(204, 158, 73, 0.1)"
              },
              padding: "8px 12px",
              borderRadius: "25px",
              transition: "background-color 0.3s ease",
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              border: "1px solid rgba(255, 255, 255, 0.1)"
            }}
          >
            <Avatar
              sx={{
                width: 40,
                height: 40,
                backgroundColor: "#E1AD01",
                color: "#000",
                fontWeight: 700,
                fontSize: "18px"
              }}
            >
              {getUserInitials()}
            </Avatar>
            <Box sx={{ flex: 1 }}>
              <Typography sx={{
                color: "#FFFFFF",
                fontSize: "16px",
                fontWeight: 500,
                lineHeight: 1.3
              }}>
                {getUserName()}
              </Typography>
              <Typography sx={{
                color: "rgba(255, 255, 255, 0.7)",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: 1.2
              }}>
                Admin
              </Typography>
            </Box>
            <KeyboardArrowDown sx={{
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: 18
            }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            height: "100vh",
            boxSizing: "border-box",
            backgroundColor: "rgba(26, 26, 26, 1) !important",
            borderRight: "none",
            overflow: "hidden",
            position: "relative",
            borderBottomRightRadius: "40px",
          },
        }}
      >
        {drawerContent}
      </Drawer>

      {/* Desktop Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          width: { xs: 0, md: drawerWidth },
          flexShrink: 0,
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            height: "100vh",
            boxSizing: "border-box",
            backgroundColor: "rgba(26, 26, 26, 1)",
            borderRight: "none",
            overflow: "hidden",
            position: "relative",
            borderBottomRightRadius: "40px",
          },
        }}
      >
        {drawerContent}
      </Drawer>

      {/* Logout Modal */}
      <LogoutModal
        open={logoutModalOpen}
        onClose={handleCloseLogoutModal}
      />

      {/* User Menu Dropdown */}
      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "rgba(38, 38, 38, 1)",
            color: "#FFFFFF",
            minWidth: 200,
            borderRadius: "12px",
            marginTop: "-8px",
            border: "1px solid rgba(204, 158, 73, 0.2)",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.4)",
          },
        }}
      >
        {/* <MenuItem
          onClick={handleProfileClick}
          disabled={true}
          sx={{
            padding: "12px 20px",
            "&:hover": {
              backgroundColor: "rgba(204, 158, 73, 0.1)",
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <Person sx={{ color: "#E1AD01", fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText
            primary="My Profile"
            sx={{
              "& .MuiListItemText-primary": {
                fontSize: "14px",
                fontWeight: 500,
              },
            }}
          />
        </MenuItem> */}
        <MenuItem
          onClick={handleLogoutClick}
          sx={{
            padding: "12px 20px",
            "&:hover": {
              backgroundColor: "rgba(204, 158, 73, 0.1)",
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <Logout sx={{ color: "#E1AD01", fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText
            primary="Logout"
            sx={{
              "& .MuiListItemText-primary": {
                fontSize: "14px",
                fontWeight: 500,
              },
            }}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default Sidebar;